// import React, { useState } from 'react'
// import LanguageSwitcher from '../components/common/HeaderComponents/LanguageSwitcher/LanguageSwitcher'
// import MediaSwitcher from '../components/common/HeaderComponents/MediaSwitcher/MediaSwitcher'

// const languages = [
//   { code: 'en', label: 'English' },
//   { code: 'ar', label: 'Malayalam' },
// ]

// const TopHeader: React.FC = () => {
//   const [lang, setLang] = useState('en')

//   const handleLanguageChange = (newLang: string) => {
//     setLang(newLang)

//   }

//   return (
//     <div className="bg-linear-orange h-[3rem]">
//       <div className="flex justify-end items-center mx-auto lg:w-11/12 h-full lg:px-0 px-2">
//         <div className="flex items-center gap-4">
//           <LanguageSwitcher
//             languages={languages}
//             selectedLanguage={lang}
//             onChange={handleLanguageChange}
//           />
//           {/* Now shows YouTube, FB, LinkedIn inline */}
//           <MediaSwitcher />
//         </div>
//       </div>
//     </div>
//   )
// }

// export default TopHeader

import React from 'react'
import LanguageSwitcher from '../components/common/HeaderComponents/LanguageSwitcher/LanguageSwitcher'
import MediaSwitcher from '../components/common/HeaderComponents/MediaSwitcher/MediaSwitcher'
import { useAuthStore } from '../store/authStore'

const languages = [
  { code: 'lang_eng', label: 'English' },
  { code: 'lang_mal', label: 'Malayalam' },
]

const TopHeader: React.FC = () => {
  const { language, setLanguage } = useAuthStore()

  const handleLanguageChange = (newLang: string) => {
    setLanguage(newLang as 'lang_eng' | 'lang_mal')
  }
  return (
    <div className="bg-linear-orange h-[3rem]">
      <div className="flex justify-end items-center mx-auto lg:w-11/12 h-full lg:px-0 px-2">
        <div className="flex items-center gap-4">
          <LanguageSwitcher
            languages={languages}
            selectedLanguage={language}
            onChange={handleLanguageChange}
          />
          <MediaSwitcher />
        </div>
      </div>
    </div>
  )
}

export default TopHeader
